import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.Testimonial),
  () => import('./Testimonial'),
  (Testimonial) => {
    ComponentUtil.binder(Hooks.Testimonial, Testimonial);
  },
);
